import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-witnessing-system',
  standalone: true,
  imports: [],
  templateUrl: './witnessing-system.component.html',
  styleUrl: './witnessing-system.component.scss'
})
export class WitnessingSystemComponent implements OnInit {
  constructor(private route: Router, private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/witnessing-system",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);


    this.titleService.setTitle('Advanced IVF Witnessing System | Ncare IVF Centre');
    this.metaService.updateTag({
      name: 'description',
      content: 'Ensure safety and accuracy in every IVF procedure with the advanced Witnessing System at Ncare IVF Centre in Kannur. Trusted technology for secure embryo handling and patient confidence.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Witness system in IVF,  Advanced Fertility Technology'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Advanced IVF Witnessing System | Ncare IVF Centre'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Ensure safety and accuracy in every IVF procedure with the advanced Witnessing System at Ncare IVF Centre in Kannur. Trusted technology for secure embryo handling and patient confidence.'
    });
  }

  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
